import type { DeepRequired } from '../fixtures.types'

const resolvedPermissionResolution: DeepRequired<ResolvedPermissionResolution> = {
  __typename: 'ResolvedPermissionResolution' as const,
  permission_name: '',
  gate: '' as PermissionGateName,
  has_permission: true,
  assignee: null,
  scope: null,
}

export default resolvedPermissionResolution
